import { createFileRoute } from '@tanstack/react-router';
import { TenantGamConfigForm } from '@/components/tenants/TenantGamConfigForm';

export const Route = createFileRoute('/dashboard/tenant/$tenantCode/google-ads/gam-config')({
  component: GoogleAdsGamConfigRoute,
});

function GoogleAdsGamConfigRoute() {
  const { tenantCode } = Route.useParams();
  return <TenantGamConfigForm tenantCode={tenantCode} />;
}
